const tripColumns = [
  {
    label: 'Trip ID',
    value: 'code',
    textId: 'fleetadmin.trip.table.tripid',
    disabled: true,
  },
  {
    label: 'Status',
    value: 'status',
    textId: 'fleetadmin.trip.table.status',
    disabled: false,
  },
  {
    label: 'Plate No.',
    value: 'plate',
    textId: 'fleetadmin.trip.table.plate',
    disabled: false,
  },
  {
    label: 'Contract ID',
    value: 'merchantRef',
    textId: 'fleetadmin.trip.table.contractid',
    disabled: false,
  },
  {
    label: 'Fleet',
    value: 'fleetName',
    textId: 'fleetadmin.trip.table.fleet',
    disabled: false,
  },
  {
    label: 'User',
    value: 'userReferralCode',
    textId: 'fleetadmin.trip.table.user',
    disabled: false,
  },
  {
    label: 'Started at',
    value: 'tripStart',
    textId: 'fleetadmin.trip.table.startedat',
    disabled: false,
  },
  {
    label: 'Finished at',
    value: 'tripEnd',
    textId: 'fleetadmin.trip.table.finishedat',
    disabled: false,
  },
  {
    label: 'Duration',
    value: 'duration',
    textId: 'fleetadmin.trip.table.duration',
    disabled: false,
  },
  {
    label: 'Mileage',
    value: 'distance',
    textId: 'fleetadmin.trip.table.mileage',
    disabled: false,
  },
  {
    label: 'Violation: Missing key',
    value: 'violationMissionKey',
    textId: 'fleetadmin.trip.table.violation.missingkey',
    disabled: false,
  },
  {
    label: 'Violation: Missing fuel card',
    value: 'violationMissingFuelCard',
    textId: 'fleetadmin.trip.table.violation.missingfuelcard',
    disabled: false,
  },
  {
    label: 'Violation: Return area',
    value: 'violationReturnArea',
    textId: 'fleetadmin.trip.table.violation.returnarea',
    disabled: false,
  },
  {
    label: 'Violation: Low fuel',
    value: 'violationLowFuel',
    textId: 'fleetadmin.trip.table.violation.lowfuel',
    disabled: false,
  },
];

export const defaultSelectedTripColumns = tripColumns.map(
  (tripColumn) => tripColumn.value
);

export default tripColumns;
